/**
 * Canonical URL helper for shareable links and SEO metadata.
 * Use ONLY for: share profile/media kit URLs, canonical meta tags, sitemap.
 * Keep internal navigation relative (e.g. /login, /signup).
 */

const FALLBACK_BASE = 'https://influencehub.net';

function getCanonicalBaseUrl(): string {
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CANONICAL_BASE_URL) {
    return (import.meta.env as { VITE_CANONICAL_BASE_URL?: string }).VITE_CANONICAL_BASE_URL;
  }
  if (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_CANONICAL_BASE_URL) {
    return process.env.NEXT_PUBLIC_CANONICAL_BASE_URL;
  }
  return FALLBACK_BASE;
}

/**
 * Base URL for the canonical site (influencehub.net). No trailing slash.
 */
export function canonicalBaseUrl(): string {
  return getCanonicalBaseUrl();
}

/**
 * Full canonical URL for a path. Use for share links and canonical meta.
 * @param path - Path with or without leading slash (e.g. "username" or "/username")
 */
export function canonicalUrl(path: string): string {
  const base = getCanonicalBaseUrl().replace(/\/$/, '');
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}
